import React, { useEffect, useState } from "react";
import { useAppraiserApi } from "../../../context/ApiContext.tsx";
import { License } from "../../../api/ApiTypes.ts";
import { Switch } from "@headlessui/react";
import {AppraiserProfileTabProps} from "./AppraiserProfile.tsx";
import {Loader2} from "lucide-react";

export const LicenseAndCerts: React.FC<AppraiserProfileTabProps> = ({appraiserInfo}) => {
    const [licenses, setLicenses] = useState<License[]>([]);
    const appraiserApi = useAppraiserApi();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!appraiserInfo) return;

        setIsLoading(true);
        appraiserApi.getLicenseInfo(appraiserInfo.id)
            .then(setLicenses)
            .catch(console.error)
            .finally(() => setIsLoading(false));
    }, [appraiserInfo]);


    return (
        <div className="space-y-6">
            <div className="mb-4">
                <h3 className="text-lg font-medium text-slate-700">Licenses & Certifications</h3>
            </div>
            {/* FHA Certification Status */}
            {appraiserInfo && (
                <div className="p-4 border border-gray-200 rounded-md bg-white shadow-sm">
                    <div className="flex justify-between items-center">
                        <div>
                            <h3 className="text-md font-medium text-slate-700">FHA Certification</h3>
                            <p className="text-sm text-slate-500 mt-1">
                                {appraiserInfo.isFhaCertified
                                    ? "You are certified to perform FHA appraisals."
                                    : "You are not currently certified to perform FHA appraisals."}
                            </p>
                        </div>
                        <Switch
                            checked={appraiserInfo.isFhaCertified}
                            disabled={true}
                            className={`${appraiserInfo.isFhaCertified ? 'bg-gray-200' : 'bg-gray-200'} 
                                     relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2`}
                            onChange={() => {}}
                        >
                            <span
                                className={`${appraiserInfo.isFhaCertified ? 'translate-x-6' : 'translate-x-1'} 
                                        inline-block h-4 w-4 transform rounded-full bg-white transition-transform`}
                            />
                        </Switch>
                    </div>
                </div>
            )}

            {/* License List */}
            <div>
                {isLoading ? (
                    <div className="p-4 flex justify-center items-center">
                        <Loader2 className="h-8 w-8 text-blue-500 animate-spin mb-2" />
                    </div>
                ) : licenses.length === 0 ? (
                    <div className="p-4 bg-gray-50 border border-gray-200 rounded-md text-center">
                        <p className="text-slate-600">No licenses or certifications found.</p>
                    </div>
                ) : (
                    <div className="space-y-4">
                        {licenses.map(license => (
                            <div key={license.id} className="p-4 border border-gray-200 rounded-md bg-white shadow-sm">
                                <div className="flex flex-wrap justify-between">
                                    <div className="space-y-2">
                                        <div className="flex items-center space-x-2">
                                            <span className="font-medium">{license.type}</span>
                                            <span className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs">
                                    {license.stateCode}
                                </span>
                                        </div>
                                        <div className="text-sm text-slate-600">
                                            <div>OG#: {license.ogNumber}</div>
                                            <div>Expires: {new Date(license.expirationDate).toLocaleDateString()}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {/* Information Section */}
            <div className="p-3 bg-blue-50 border border-blue-200 rounded-md mt-6">
                <p className="text-sm text-blue-700">
                    <strong>Note:</strong> Please contact support if this information is incorrect.
                </p>
            </div>
        </div>
    );
};